<template>
   <div>
      <div class="row p-2 mt-4">
         <div class="col-12">
            <span class="custom-span-lg" style="color: #435666;">Configuration
               <i class="fa-solid fa-arrow-right"></i>
            </span>
            <span class="custom-span-no-weight" style="color: #435666;"> &nbsp;Allow List</span>
            <div class="mt-2">
               <small class="text-muted">
                  <i class="fa-solid fa-circle-info me-1" style="color: #00A0C1;"></i>
                   Use the <strong>domainname.com</strong> format when adding websites. Wildcards (<strong>*.example.com</strong>, <strong>example.com/path/*</strong>), CIDR notation (<strong>192.168.1.0/24</strong>), IPs, and localhost are also supported. Ports are ignored by default. <strong>Please note:</strong> Localhost is always allowed. It may take up to 30 minutes for this change to be reflected in your browser. Page refresh is required.
               </small>
            </div>
         </div>
      </div>

      <AllowList />
   </div>
</template>

<script>
import AllowList from '@/components/AllowList/AllowList2.vue';

export default {

   components: {
      AllowList,
   },

}

</script>

<style scoped>
.custom-span-lg {
   font-size: 24px;
   line-height: 24px;
   font-weight: bold;
}

.custom-span-no-weight {
   font-size: 24px;
   line-height: 24px;
   font-weight: 250;
}
</style>